"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBDataTable", {
  enumerable: true,
  get: function get() {
    return _SVBDataTable.default;
  }
});
var _SVBDataTable = _interopRequireDefault(require("./src/SVBDataTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }